export default __webpack_public_path__ + "static/media/33.1d1249a0.png";